import { marketingCategories, salesCategories, serviceCategories } from 'academy-common-lib/constants/categories';
import I18n from 'I18n';
const applySmartCategoryGrouping = data => {
  const categoryGroups = [{
    subcategories: marketingCategories,
    parentName: 'MARKETING'
  }, {
    subcategories: salesCategories,
    parentName: 'SALES'
  }, {
    subcategories: serviceCategories,
    parentName: 'SERVICE'
  }];
  const result = [];
  const processedCategories = new Set();
  categoryGroups.forEach(({
    subcategories,
    parentName
  }) => {
    const categoriesBelongingToParent = data.filter(item => subcategories.includes(item.category));
    if (categoriesBelongingToParent.length >= 3) {
      const total = categoriesBelongingToParent.reduce((sum, item) => sum + item.total, 0);
      result.push({
        category: parentName,
        total
      });
      categoriesBelongingToParent.forEach(item => {
        processedCategories.add(String(item.category));
      });
    }
  });
  data.forEach(item => {
    if (!processedCategories.has(String(item.category))) {
      result.push(item);
    }
  });
  return result;
};
export const getActiveCertsChartOptions = data => ({
  chart: {
    type: 'pie',
    height: 375,
    spacingTop: 20
  },
  legend: {
    enabled: true,
    align: 'center',
    verticalAlign: 'top',
    layout: 'horizontal',
    margin: 15,
    padding: 0,
    itemStyle: {
      fontWeight: 'normal',
      cursor: 'default',
      pointerEvents: 'none'
    },
    floating: false
  },
  tooltip: {
    enabled: true
  },
  plotOptions: {
    pie: {
      borderWidth: 0,
      size: '80%',
      innerSize: '70%',
      showInLegend: true,
      allowPointSelect: false,
      dataLabels: {
        enabled: true,
        format: '{point.percentage:.0f}%'
      },
      events: {
        legendItemClick: () => false
      }
    }
  },
  series: [{
    type: 'pie',
    name: I18n.text(`learningCenter.myTeam.overview.certifications.certificationsByTopic.activeCertifications`),
    enableMouseTracking: true,
    data,
    showInLegend: true,
    allowPointSelect: false
  }]
});
export const getActiveCertsChartData = data => {
  if (data.length <= 6) {
    const sortedData = [...data].sort((a, b) => b.total - a.total);
    return sortedData.map(({
      category,
      total
    }) => ({
      name: I18n.text(`academyCommon.categories.${category}`),
      y: total
    }));
  }
  const groupedData = applySmartCategoryGrouping(data);
  const sortedData = [...groupedData].sort((a, b) => b.total - a.total);
  if (sortedData.length <= 5) {
    return sortedData.map(({
      category,
      total
    }) => ({
      name: I18n.text(`academyCommon.categories.${category}`),
      y: total
    }));
  }
  const topFiveData = sortedData.slice(0, 5);
  const remainingTotal = sortedData.slice(5).reduce((acc, curr) => acc + curr.total, 0);
  const formattedData = topFiveData.map(({
    category,
    total
  }) => ({
    name: I18n.text(`academyCommon.categories.${category}`),
    y: total
  }));
  formattedData.push({
    name: I18n.text('learningCenter.myTeam.overview.certifications.certificationsByTopic.other'),
    y: remainingTotal
  });
  return formattedData;
};